import axios from "../axios";
class StockService {
  static Instance() {
    return new StockService();
  }

  getAllStocks(request) {
    return axios.post("/api/stock/list/all", request);
  }

  updateStock(request) {
    return axios.put("/api/stock", request);
  }

  addStock(request) {
    return axios.post("/api/stock", request);
  }

  getStockData(stockID) {
    return axios.get("/api/stock/enquiry?stockID= " + stockID);
  }

  exportToExcel(request) {
    return axios.post("/api/stock/list/export", request, {
      responseType: "blob",
    });
  }

  downloadImportTemplate() {
    return axios.get("/api/stock/import/format/generate", {
      responseType: "blob",
    });
  }

  uploadStockData(formData) {
    return axios.post("/api/stock/import", formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  }
}
export default StockService.Instance();
